import React from "react";

const ButtonLoader = () => {
  return (
    <button className="buttonload group relative flex items-center btn btn-theme px-[20px] text-white focus:outline-none btn btn-theme w-50%">
      <span className="left-[20px] inset-y-0 flex items-center">
        <img className="fa-spin h-6" src="/Spinne.png" alt="" />
      </span>
      <span className="ml-5 text-lg mobile-14">
        Loading
      </span>
    </button>
  );
};

export default ButtonLoader;